//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// const ADD_URL = URL_APP + "api/v1/rincian_obyek/";
import FETCHING from  '../library/fetching'

  import Joi from "joi";
  const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(3).max(13).required(),
    password: Joi.string().min(6).required(),
  });

  import { Notify, LoadingBar  } from 'quasar'

  export default {
    name: "monev_login",
    data : function(){
      return {

          errorMessage: '',
          user : {
            username : "",
            password : ""
          },
          list_menu : [],
          FETCHING : FETCHING,

          url : {
            LOGIN_URL : this.$store.state.url.URL_APP + "auth/login",

          },
          Loadingku : false,
      }
    },
    watch: {
      user: {
          handler() {
              this.errorMessage = "";
          },
          deep: true
      }
    },
    methods: {
      // go_register : function(){
      //   alert(App.data().sesseee);
      //   this.displayed = 'block';
      // },
      btn_login : async function(){

        

        this.errorMessage = '';
        if(this.validUser()){
          // this.$store.commit("shoWLoading");
          this.Loadingku = true;
          // this.$q.notify("hi");

          // this.$store.commit("shoWNotify", 'Kiken', 'primary', 'timer');
          const body = {
            username : this.user.username,
            password : this.user.password
          }
          fetch(this.url.LOGIN_URL, {
            method : 'POST',
            headers : {
              'content-type' : 'application/json',
            },
            body : JSON.stringify(body),
          }).then((response) => {
            
            console.log(response);
            
                if (response.ok) {
                    return response.json();
                    // this.$store.commit("shoWLoading");
                    this.Loadingku = true;
                }

                return response.json().then(error => {
                    throw new Error(error.message);
                    // this.$store.commit("shoWLoading");
                    this.Loadingku = true;
                });
            })
            .then(async (result) => {
              console.log("=============================");
              // console.log(result);
              // menyimpan token yang tergenerate dari server
              localStorage.token = result.token;
              localStorage.profile = JSON.stringify(result.profile);


              console.log(result.profile.profile)

              var lev = result.profile.profile


              this.list_menu = await this.FETCHING.getEditMenuListLevelAkses_Login(lev.level);
              localStorage.menu = JSON.stringify(this.list_menu);


              // this.Loadingku = false;
              // this.$router.push('/ktp');
              

              setTimeout(() => {
                // this.$store.commit("hideLoading")

                this.Loadingku = false;
                location.reload(this.$router.push('/ktp'));
              }, 1000);
            })
            .catch(error => {
              setTimeout(() => {
                this.Loadingku = false;
                // this.$store.commit("hideLoading")
                this.errorMessage = error.message;
              }, 1000);
            });
        }



      },
      validUser: function(){
        const result = Joi.validate(this.user, schema);
        if (result.error === null) {
          return true;
        }
        if (result.error.message.includes("username")) {
          this.errorMessage = "Username tidak valid";
        } else {
          this.errorMessage = "Password tidak valid";
        }
        return false;
      },
    },

    mounted : function(){
      // var element = document.getElementById('main_menu');
      // element.parentNode.removeChild(element);  
    },    
}
